export default {
  methods: {
    async getImgBase64(imageURL) {
      try {
        const response = await fetch(imageURL);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              resolve(reader.result.split(',')[1]);
            } else {
              reject(new Error('reader.result is not a string.'));
            }
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('Error converting image to base64:', error);
        return null;
      }
    },
    async prepareLogo(data) {
      if (data) {
        let printData = JSON.parse(data);
        for (let item of printData) {
          let logoPath = null, logo58Path = null, logo18Path = null;

          try {
            if (item.logo === "loto-hotpicks") {
              logo58Path = require('ThemePath/img/print/logo-loto-hotpicks.jpg')
              logoPath = require('ThemePath/img/print/logo-loto-hotpicks-2x.jpg')
            } else if (item.logo === "loto-vert-hotpicks") {
              logo58Path = require('ThemePath/img/print/logo-loto-vert-hotpicks.jpg')
              logoPath = require('ThemePath/img/print/logo-loto-vert-hotpicks-2x.jpg')
            } else if (item.logo === 'loto-plus-hotpicks') {
              logo58Path = require('ThemePath/img/print/logo-loto-plus-hotpicks.jpg')
              logoPath = require('ThemePath/img/print/logo-loto-plus-hotpicks-2x.jpg')
            } else if (item.logo === "both") {
              logo58Path = require('ThemePath/img/print/logo-both.jpg')
              logoPath = require('ThemePath/img/print/logo-both-2x.jpg')
            } else if (item.logo === "18") {
              logo18Path = require('ThemePath/img/print/18-icon.jpg')
            }
          } catch (e) {
            console.log('crash when require logo')
          }

          if (item.logo !== undefined) item.base64logos = {
            "logo58": logo58Path ? await this.getImgBase64(logo58Path) : "",
            "logo": logoPath ? await this.getImgBase64(logoPath) : "",
            "logo18": logo18Path ? await this.getImgBase64(logo18Path) : ""
          }
        }
        return printData;
      }
    },
    async prepareLogoAsSingleObject(data) {
      if (data) {
        let printData = JSON.parse(data);
        let base64logos = {};
        for (let item of printData) {
          let logoPath = null, logo58Path = null, logo18Path = null;

          try {
            if (base64logos[item.logo]) continue;

            // 18 icon using 1 image for both devices (80 and 58)
            if (item.logo === "18") {
              logo18Path = require('ThemePath/img/print/18-icon.jpg')
              base64logos[item.logo] = {};
              base64logos[item.logo].logo = await this.getImgBase64(logo18Path)
              continue;
            }

            // other logos will have 2 versions
            if (item.logo === "loto-hotpicks") {
              logo58Path = require('ThemePath/img/print/logo-loto-hotpicks.jpg')
              logoPath = require('ThemePath/img/print/logo-loto-hotpicks-2x.jpg')
            } else if (item.logo === "loto-vert-hotpicks") {
              logo58Path = require('ThemePath/img/print/logo-loto-vert-hotpicks.jpg')
              logoPath = require('ThemePath/img/print/logo-loto-vert-hotpicks-2x.jpg')
            } else if (item.logo === 'loto-plus-hotpicks') {
              logo58Path = require('ThemePath/img/print/logo-loto-plus-hotpicks.jpg')
              logoPath = require('ThemePath/img/print/logo-loto-plus-hotpicks-2x.jpg')
            } else if (item.logo === "both") {
              // all logos (3 logo)
              logo58Path = require('ThemePath/img/print/logo-both.jpg')
              logoPath = require('ThemePath/img/print/logo-both-2x.jpg')
            } else {
              // no defined logos, ignore
              continue;
            }

            base64logos[item.logo] = {};
            base64logos[item.logo].logo = await this.getImgBase64(logoPath)
            base64logos[item.logo].logo58 = await this.getImgBase64(logo58Path)

          } catch (e) {
            console.log('crash when require logo')
          }
        }

        printData.unshift({ base64logos: base64logos });

        return printData;
      }
    }
  },
};
